import React, { useState } from "react";
import UploadVideo from "../../assets/images/uploadVideo.png";
import { toast } from "react-toastify";
import { uploadIntroVideo } from "../../api/uploadMedia";
import CopyUploadedUrl from "./CopyUploadedUrl";

const UploadedIntroVideo = ({refresh}) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [uploadedUrl, setUploadedUrl] = useState("");
  const [setAlertText] = useState("");
  const [setDialogOpen] = useState(false);
  const [dialogShow, setDialogShow] = useState(false);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    resetFileState();

    if (selectedFile) {
      if (selectedFile.size > 83886080) {
        setError("File size must be less than 80 MB.");
      } else {
        setFile(selectedFile);
        setFileName(selectedFile.name);
        setUploadedFileName(selectedFile.name)
        setError("");
      }
    }
  };

  const resetFileState = () => {
    setFile(null);
    setFileName("");
    setError("");
    setAlertText("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      setError("Please select a valid video file to upload.");
      return;
    }

    try {
      setLoading(true);
      const response = await uploadIntroVideo(file, fileName);

      if (response.status === 201) {
        setUploadedUrl(response.data.url);
        resetFileState();
        toast.success("Your intro video was uploaded successfully!", {
          position: "top-center",
          autoClose: 5000,
        });
        refresh()
        setDialogShow(true);
      } else {
        setError("Something went wrong! Please try again later.");
        setAlertText("Please ensure that your video format is correct.");
        setDialogOpen(true);
      }
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error.message);
      setError("There was an error uploading the intro video.");
      setAlertText("Check your internet connection and try again.");
      setDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setDialogShow(false);
    setUploadedFileName("")
  };

  return (
    <div className="container d-flex flex-column ">
      <div className="card shadow-sm rounded ">
        <div className="card-header text-center text-white py-3" style={{ backgroundColor: "#1E70C8" }}>
          <h5 className="mb-0">Upload Your Intro Video</h5>
          <p className="mb-0 small">Select a video for your introduction</p>
        </div>
        <div className="card-body">
          <div className="text-center mb-3 justify-content-center d-flex">
            <button
              type="button"
              className="btn btn-outline-secondary d-flex justify-content-center align-items-center"
              onClick={() => document.getElementById("videoFileInput").click()}
              style={{ width: "70px", height: "70px", borderRadius: "50%", border: "2px dashed #ccc" }}
            >
              <img src={UploadVideo} alt="Upload Video" style={{ width: "40px", height: "40px" }} />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="text-center">
            <input
              type="file"
              accept="video/*"
              onChange={handleFileChange}
              required
              className="d-none"
              id="videoFileInput"
            />
            <div className="form-group mb-3">
              <input
                type="text"
                placeholder="Selected Video"
                value={fileName}
                readOnly ={!file}
                onChange={(e) => {setFileName(e.target.value); setUploadedFileName(e.target.value) }}
                className="form-control text-center"
                style={{ backgroundColor: "#f8f9fa" }}
              />
            </div>
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={!file || loading}
              style={{ backgroundColor: "#1E70C8" }}
            >
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Upload Video"
              )}
            </button>
          </form>
        </div>
      </div>
      <CopyUploadedUrl show={dialogShow} handleClose={handleCloseDialog} url={uploadedUrl}  fileName={uploadedFileName} />
      {/* <CopyUploadedUrl show={isDialogOpen} handleClose={() => setDialogOpen(false)} title="Upload Error">
        <p>{alertText}</p>
      </CopyUploadedUrl> */}
    </div>
  );
};

export default UploadedIntroVideo;